export default __webpack_public_path__ + "static/media/project-lego.a3df1b70.webp";